import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, Users, Settings, MessageSquare, SlidersHorizontal, MapPin } from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: Home },
    { path: '/admin/festivals', label: 'Festivals', icon: Calendar },
    { path: '/admin/feedback', label: 'Feedback', icon: MessageSquare },
    { path: '/admin/users', label: 'Users', icon: Users },
    { path: '/admin/friend-finder', label: 'Friend Finder', icon: MapPin },
    { path: '/admin/parameters', label: 'Parameters', icon: SlidersHorizontal },
    { path: '/admin/settings', label: 'Settings', icon: Settings }
  ];

  return (
    <nav className="sidebar">
      <ul style={{ listStyle: 'none' }}>
        {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname.startsWith(item.path);
          
          return (
            <li key={item.path} style={{ marginBottom: '10px' }}>
              <Link
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  textDecoration: 'none',
                  color: isActive ? '#007bff' : '#666',
                  backgroundColor: isActive ? '#f0f8ff' : 'transparent',
                  borderRadius: '6px',
                  transition: 'all 0.2s'
                }}
              >
                <Icon size={20} />
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;
